"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _Theme = _interopRequireDefault(require("../Theme"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Text = _interopRequireDefault(require("../Text"));

var _constant = require("../constant");

var _GuestOfwInfo = require("../GuestOfwInfo");

var _GuestPersonalInfo = require("../GuestPersonalInfo");

var _constant2 = require("./constant");

var _WheelchairPwdInfo = _interopRequireDefault(require("./WheelchairPwdInfo.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "WheelchairPwdInfo__StyledContainer",
  componentId: "sc-el0x-0"
})(["margin:", ";"], function (_ref) {
  var customMargin = _ref.customMargin;
  return customMargin || 0;
});

var HeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "WheelchairPwdInfo__HeaderContainer",
  componentId: "sc-el0x-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return "\n  padding: 0px ".concat(theme.space.tiny, ";\n");
});

var TitleContainer = _styledComponents.default.div.withConfig({
  displayName: "WheelchairPwdInfo__TitleContainer",
  componentId: "sc-el0x-2"
})(["display:flex;flex-direction:row;align-items:center;"]);

var SubTitleContainer = _styledComponents.default.div.withConfig({
  displayName: "WheelchairPwdInfo__SubTitleContainer",
  componentId: "sc-el0x-3"
})([""]);

var ToolTipTitle = _styledComponents.default.div.withConfig({
  displayName: "WheelchairPwdInfo__ToolTipTitle",
  componentId: "sc-el0x-4"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize.normal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.large;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.neutral;
});

var Content = _styledComponents.default.div.withConfig({
  displayName: "WheelchairPwdInfo__Content",
  componentId: "sc-el0x-5"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-top:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontFamily.default;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize.small;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeight.normal;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.greyDarker;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.micro;
});

var WheelchairPwdInfo = function WheelchairPwdInfo(_ref14) {
  var accessible = _ref14.accessible,
      theme = _ref14.theme,
      customProperties = _ref14.customProperties,
      initialValues = _ref14.initialValues,
      translation = _ref14.translation,
      handleField = _ref14.handleField,
      pwdIdMaxChar = _ref14.pwdIdMaxChar,
      formRef = _ref14.formRef,
      onSubmit = _ref14.onSubmit,
      hideForm = _ref14.hideForm,
      errorCallback = _ref14.errorCallback,
      customMargin = _ref14.customMargin,
      onFocusHandler = _ref14.onFocusHandler;

  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };

  var _React$useState = _react.default.useState(innerWidth()),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      windowWidth = _React$useState2[0],
      setWindowWidth = _React$useState2[1];

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
  }, []);

  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);

  var isMobile = windowWidth <= parseInt(_constant.BREAKPOINTS.MOBILE.replace('px', ''), 10);

  var returnToolTipText = function returnToolTipText() {
    return /*#__PURE__*/_react.default.createElement(_GuestOfwInfo.ToolTipContent, null, /*#__PURE__*/_react.default.createElement(ToolTipTitle, null, language.pwdNoteTitle), /*#__PURE__*/_react.default.createElement(Content, null, language.pwdNote));
  };

  var returnToolTipContent = function returnToolTipContent() {
    return /*#__PURE__*/_react.default.createElement(_GuestOfwInfo.ToolTipContainer, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
      theme: theme,
      accessible: accessible,
      asToolTip: !isMobile,
      content: returnToolTipText(),
      position: "TOP",
      trigger: isMobile ? 'click' : 'hover',
      width: 320
    }, (0, _GuestOfwInfo.returnToolTipIcon)(theme, accessible)));
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, {
    customMargin: customMargin,
    tabIndex: !accessible ? '-1' : '0'
  }, !hideForm && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeaderContainer, null, /*#__PURE__*/_react.default.createElement(TitleContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    bold: true,
    theme: theme,
    type: "sub"
  }, language.pwdTitle), returnToolTipContent()), /*#__PURE__*/_react.default.createElement(SubTitleContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    bold: true,
    theme: theme,
    type: "small",
    color: "greyDark"
  }, language.pwdSubTitle))), /*#__PURE__*/_react.default.createElement(_formik.Formik, (0, _extends2.default)({
    innerRef: formRef,
    initialValues: initialValues,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, customProperties, {
    validateOnChange: true
  }), function (props) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      _react.default.createElement("form", {
        onSubmit: props.handleSubmit,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            props.handleSubmit();
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: 100
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.pwdTextLabel || _constant2.FIELDS.pwdId.label,
        name: _constant2.FIELDS.pwdId.name,
        theme: theme,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.pwdId.name] || null,
        validate: function validate(val) {
          return (0, _GuestPersonalInfo.validators)((0, _GuestPersonalInfo.removeExtraWhiteSpaces)(val), language.pwdTextLabel || _constant2.FIELDS.pwdId.label, language, pwdIdMaxChar ? [_GuestPersonalInfo.validate.maxLen, _GuestPersonalInfo.validate.alphanumeric] : [_GuestPersonalInfo.validate.alphanumeric], pwdIdMaxChar, _constant2.FIELDS.pwdId.name);
        },
        isRequired: props.values[_constant2.FIELDS.pwdId.name] !== '',
        errorCallback: errorCallback,
        touched: props.touched[_constant2.FIELDS.pwdId.name],
        triggerOnChange: true,
        onFocus: onFocusHandler
      })))
    );
  }))));
};

WheelchairPwdInfo.propTypes = _WheelchairPwdInfo.default.PropTypes;
WheelchairPwdInfo.defaultProps = _WheelchairPwdInfo.default.DefaultProps;
var _default = WheelchairPwdInfo;
exports.default = _default;